var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Secondary Tertiary Nav")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('secondary-tertiary-nav')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e4da336","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./demo/pages/components/phd-secondary-tertiary-nav.vue
// module id = 1594
// module chunks = 0